const TEST_NAME_ACADEMY = 'academy';

export { TEST_NAME_ACADEMY };
